export const teamMembers = [
  { key: "amit_lavhare", name: "Amit Lavhare" },
  { key: "sagar_shinde", name: "Sagar Shinde" },
  { key: "neha_panchamiya", name: "Neha Panchamiya" },
  { key: "tuhin_satarkar", name: "Tuhin Satarkar" },
  { key: "nachiket_utpat", name: "Nachiket Utpat" },
] as const;

export type TeamMemberKey = (typeof teamMembers)[number]["key"];

/** Media Comms people who shoot/collect media and edit videos.
 *  Follow-up (media collection) and video-editing are assigned from this subset. */
export const mediaTeam = teamMembers.filter((m) =>
  (["amit_lavhare", "sagar_shinde"] as string[]).includes(m.key),
);

export function teamMemberName(key: string | null | undefined): string | null {
  return teamMembers.find((member) => member.key === key)?.name ?? null;
}
